var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"message__text",style:(`font-size: ${_vm.messageSizeRem}rem`)},[_vm._m(0),_vm._v(" "),_c('a',{staticClass:"message__link",attrs:{"target":"_blank","rel":"noreferrer"},on:{"click":_vm.redirect}},[_vm._v(_vm._s(_vm.message.src))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('i',{staticClass:"button__icon icon icon_cristal"})])
}]

export { render, staticRenderFns }